module.exports = __webpack_public_path__ + "assets/img/line4.d458e8aa.png";